import { Box } from '@src/shared/ui/layout';
import { usePageLayoutSlots } from './hooks';

export default function Header() {
  const { pageHeaderSlot } = usePageLayoutSlots();
  if (!pageHeaderSlot) {
    return null;
  }
  return <Box>{pageHeaderSlot}</Box>;
}
